<template>
  <Head :title="newsItem.meta_title || newsItem.title">
    <meta
      name="description"
      :content="newsItem.meta_description || newsItem.excerpt"
    >
    <meta
      name="og:description"
      :content="newsItem.meta_description || newsItem.excerpt"
    >
    <meta
      name="og:title"
      :content="newsItem.meta_title || newsItem.title"
    >
    <meta
      name="title"
      :content="newsItem.meta_title || newsItem.title"
    >
    <link
      rel="canonical"
      :href="localeRoute('frontend.news.show', [newsItem.categories[0], newsItem])"
    >
    <meta
      property="og:image"
      content="/frontend/assets/favicon/og-image.jpg"
    >
  </Head>

  <section
    class="blog-single-hero pt-10"
    :class="newsItem.coverImage? 'pb-20 md:pb-40 lg:pb-48' : ''"
  >
    <div class="container relative">
      <div class="flex flex-wrap">
        <div class="w-1/2">
          <Link
            :href="localeRoute('frontend.news.index')"
            class="text-gray-300 hover:underline"
          >
            <img
              src="/frontend/assets/arrow.svg"
              class="mr-4 inline"
            >
            {{ __('news-item.back') }}
          </Link>
        </div>

        <div class="w-1/2">
          <span class="block text-gray-300 text-right">
            {{ newsItem.createdAt }}
          </span>
        </div>
      </div>

      <div class="text-center mt-6">
        <span
          v-if="newsItem.categories.length"
          class="text-red font-bold block"
        >
          {{ newsItem.categories[0].name }}
        </span>

        <span class="text-4xl font-bold mt-1 lg:text-7xl text-center">
          {{ newsItem.title }}
        </span>

        <div class="mt-6 flex flex-wrap space-x-1 justify-center">
          <Link
            v-for="newsCategory in newsItem.categories"
            :key="`news-category-${newsCategory.slug}`"
            :href="localeRoute('frontend.categories.slug', [newsCategory.slug])"
            class="text-gray-300 border border-gray-300 rounded py-1 px-2 text-sm"
          >
            {{ newsCategory.name }}
          </Link>
        </div>

        <div class="my-6 flex flex-wrap space-x-6 justify-center">
          <a :href="`http://www.facebook.com/sharer.php?u=${localeRoute('frontend.news.show', [newsItem.categories[0], newsItem])}`">
            <img
              src="/frontend/assets/social/facebook.svg"
              class="lg:w-6"
            >
          </a>
          <a :href="`https://api.whatsapp.com/send?text=Bekijk+dit+artikel+op+ShoutOut.vip%3A+${localeRoute('frontend.news.show', [newsItem.categories[0], newsItem])}`">
            <img
              src="/frontend/assets/social/whatsapp.svg"
              class="lg:w-6"
            >
          </a>
          <a :href="`http://twitter.com/intent/tweet/?text=Bekijk+dit+artikel+op+ShoutOut.vip&url=${localeRoute('frontend.news.show', [newsItem.categories[0], newsItem])}&via=ShoutOut.vip`">
            <img
              src="/frontend/assets/social/twitter.svg"
              class="lg:w-6"
            >
          </a>
        </div>
      </div>

      <img
        v-if="newsItem.coverImage"
        :src="newsItem.coverImage.url"
        class="absolute left-0 right-0 max-h-96 mx-auto px-[15px]"
      >
    </div>
  </section>

  <section
    class="blog-single-content  bg-white text-lg pb-4"
    :class="newsItem.coverImage? 'pt-32 lg:pt-72 md:pt-52 xl:pt-80' : 'pt-20'"
  >
    <div class="container">
      <div class="lg:w-4/5 lg:mx-auto">
        <span class="text-2xl lg:text-4xl mt-8 mb-8 font-bold text-center sparkle-blog block indent-3 lg:indent-6 xl:indent-10">
          {{ newsItem.excerpt }}
        </span>
        <!-- eslint-disable vue/no-v-html -->
        <div v-html="newsItem.content" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </section>

  <section class="blog-single-share py-10 bg-white">
    <div class="container">
      <h2 class="text-4xl font-bold text-center lg:text-5xl">
        Deel dit bericht met je vrienden
      </h2>

      <div class="my-6 flex flex-wrap space-x-6 justify-center">
        <a :href="`http://www.facebook.com/sharer.php?u=${localeRoute('frontend.news.show', [newsItem.categories[0], newsItem])}`">
          <img
            src="/frontend/assets/social/facebook.svg"
            class="w-8"
          >
        </a>
        <a :href="`https://api.whatsapp.com/send?text=Bekijk+dit+artikel+op+ShoutOut.vip%3A+${localeRoute('frontend.news.show', [newsItem.categories[0], newsItem])}`">
          <img
            src="/frontend/assets/social/whatsapp.svg"
            class="w-8"
          >
        </a>
        <a :href="`http://twitter.com/intent/tweet/?text=Bekijk+dit+artikel+op+ShoutOut.vip&url=${localeRoute('frontend.news.show', [newsItem.categories[0], newsItem])}&via=ShoutOut.vip`">
          <img
            src="/frontend/assets/social/twitter.svg"
            class="w-8"
          >
        </a>
      </div>
    </div>
  </section>

  <section class="home-vips relative py-12">
    <div class="container">
      <h2 class="text-4xl font-bold px-10 text-center lg:text-6xl mt-6">
        {{ __('news-item.promotion.title') }}
      </h2>

      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-2 gap-4 lg:gap-8 mt-8">
        <Vip
          v-for="popularVip in popularVips"
          :key="`vip-${popularVip.username}`"
          :vip="popularVip"
        />
      </div>

      <div class="text-center mt-8 lg:mt-12">
        <Link
          :href="localeRoute('frontend.index')"
          class="button-orange shadow-button-black inline-block"
        >
          {{ __('general.see-all-vips') }}
        </Link>
      </div>
    </div>
  </section>

  <LatestNews :news-items="latestNewsItems" />
</template>

<script>
import Vip from '../../Components/Vip.vue';
import LatestNews from '../../Components/LatestNews.vue';

export default {
  components: {
    Vip,
    LatestNews,
  },

  props: {
    newsItem: {
      type: Object,
      required: true,
    },

    popularVips: {
      type: Array,
      required: true,
    },

    latestNewsItems: {
      type: Array,
      required: true,
    },
  },
};
</script>
